import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import abdooLogo from 'employee/src/logos/Abdoo logo_512px-height.png';
import { AbdooLogo } from '../../logos';
export const WelcomePage = () => {
    return (_jsx(Box, { sx: { marginTop: '1em' }, children: _jsxs(Grid, { container: true, justifyContent: "center", children: [_jsxs(Grid, { item: true, children: [_jsx("p", { children: "To get started, please complete the following information about your current holiday year." }), _jsx("p", { children: "You can go back at any time to change information, just click the back button." })] }), _jsx(Grid, { item: true, children: _jsx(AbdooLogo, { src: abdooLogo, sx: {
                            height: '5em',
                            display: 'block',
                            marginTop: '2.5em',
                            marginBottom: '2em',
                        } }) })] }) }));
};
